import { useEffect } from "react";
import { NumericFormat } from "react-number-format";
import { TextField } from "@mui/material";
import withNumberFormatValidate from "./internal/withNumberFormatValidate";
import useForm from "../common/AsyncFormBox/useForm";
import ParseUtils from "../../utils/ParseUtils";

/**
 * Formatted numeric input. Stores a number on the form when `name` is set, and still calls `onValueChange`.
 * @param {Object} props - TextField and NumericFormat props
 * @param {string} [props.name]
 * @param {string|number} [props.defaultValue]
 * @param {(values: { floatValue?: number }, sourceInfo: Object) => void} [props.onValueChange]
 */
function NumberField(props) {
  const { thousandSeparator, decimalSeparator, name, defaultValue, onValueChange, ...rest } = props;
  const form = useForm();

  // Initialize numeric value in form context on mount
  useEffect(() => {
    if (form && name && defaultValue !== undefined && defaultValue !== "") {
      const numericValue = ParseUtils.parseNumber(defaultValue);
      if (numericValue !== undefined) {
        form.setValue(name, numericValue);
      }
    }
  }, [form, name, defaultValue]);

  /**
   * @param {{ floatValue?: number }} values
   * @param {Object} sourceInfo
   */
  function handleValueChange(values, sourceInfo) {
    if (form && name) {
      form.setValue(name, values.floatValue ?? undefined);
    }
    onValueChange?.(values, sourceInfo);
  }

  return (
    <NumericFormat
      {...rest}
      name={name}
      defaultValue={defaultValue}
      customInput={TextField}
      thousandSeparator={thousandSeparator || " "}
      decimalSeparator={decimalSeparator || ","}
      onValueChange={handleValueChange}
      valueIsNumericString
    />
  );
}

export default withNumberFormatValidate(NumberField);
